import React, { useState } from "react";
import services from "../Data/ServiceData";

const Refer = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    date: "",
    location: "",
    friendName: "",
    friendLastName: "",
    friendLocation: "",
    friendNumber: "",
    friendEmail: "",
    serviceTitle: "",
  });
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formUrl = "https://api.web3forms.com/submit";

    const payload = {
      access_key: "86d67585-4e7c-4efc-9823-8511ca502c69",
      ...formData,
    };

    try {
      const response = await fetch(formUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setMessage("Form submitted successfully!");
        setFormData({
          name: "",
          number: "",
          email: "",
          date: "",
          location: "",
          friendName: "",
          friendLastName: "",
          friendLocation: "",
          friendNumber: "",
          friendEmail: "",
          serviceTitle: "",
        });
      } else {
        alert("Failed to submit the form. Please try again later.");
      }
    } catch (error) {
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div className="relative bg-zinc-800 text-white h-[50vh]">
        <img
          src="/assets/refer/refer.jpg"
          alt="ourproject background"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="relative z-10 p-8 flex flex-col items-center">
          <nav className="flex space-x-4 text-sm">
            <a href="/" className="text-gray-300 hover:text-white">
              Home
            </a>
            <span className="text-gray-300">/</span>
            <a href="/about" className="text-gray-300 hover:text-white">
              About
            </a>
          </nav>
          <h1 className="text-4xl font-bold mt-4">ABOUT JS</h1>
        </div>
      </div>
      <div className="min-h-screen flex mt-4 items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
        <div className="w-full space-y-8 rounded-lg shadow-md">
          <div
            className="relative w-full text-white p-6 rounded-lg shadow-md bg-cover bg-center"
            style={{
              backgroundImage: `url('/assets/refer/a.jpg')`,
            }}
          >
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>

            {/* Content */}
            <div className="relative">
              <h1 className="text-3xl text-yellow-400 font-bold text-center mb-6">
                Refer Your Friends to Yuvraj Mehandi Artist!
              </h1>
              <p className="text-lg mb-4">
                Yuvraj Mehandi Artist specializes in crafting stunning and
                intricate mehndi designs that add charm and elegance to every
                occasion. Whether it’s a wedding, festival, or special
                celebration, our designs blend tradition with innovation,
                creating a unique story for every client.
              </p>
              <h2 className="text-2xl text-yellow-400 font-semibold mb-4">
                Why Refer Your Friends?
              </h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>
                  <strong>Exclusive Discounts:</strong> Earn discounts on your
                  next mehndi service when your friends book with us.
                </li>
                <li>
                  <strong>Complimentary Add-ons:</strong> Get free add-on
                  designs or upgrades for every successful referral.
                </li>
                <li>
                  <strong>Celebrate Together:</strong> Introduce your loved ones
                  to the magic of Yuvraj Mehandi Artist and make every occasion
                  unforgettable.
                </li>
              </ul>
              <h2 className="text-2xl font-semibold mt-6 text-yellow-400 mb-4">
                How It Works
              </h2>
              <ol className="list-decimal ml-6 space-y-2">
                <li>Share your referral code or link with friends.</li>
                <li>
                  Your friend books our mehndi services and enjoys a
                  personalized experience.
                </li>
                <li>
                  Once their booking is complete, you unlock your rewards!
                </li>
              </ol>
              <p className="text-lg mt-6">
                Spread the beauty and elegance of mehndi while enjoying
                exclusive benefits. Start referring your friends today and let
                Yuvraj Mehandi Artist make every event even more special for you
                and your loved ones!
              </p>
            </div>
          </div>

          <div>
            <h1 className="text-3xl text-yellow-400 font-bold text-center mb-6">
              Fill below form to refer your friends
            </h1>
            {message && (
              <div className="bg-green-500 text-white p-4 rounded-lg mb-4">
                {message}
              </div>
            )}
          </div>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="lg:flex lg:space-x-4">
              <div className="flex-1">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-white"
                >
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="number"
                  className="block text-sm font-medium text-white"
                >
                  Your Number
                </label>
                <input
                  type="tel"
                  id="number"
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div className="lg:flex lg:space-x-4">
              <div className="flex-1">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-white"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="date"
                  className="block text-sm font-medium text-white"
                >
                  Date
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="location"
                className="block text-sm font-medium text-white"
              >
                Your Location
              </label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <div className="lg:flex lg:space-x-4">
              <div className="flex-1">
                <label
                  htmlFor="friendName"
                  className="block text-sm font-medium text-white"
                >
                  Friend's Name
                </label>
                <input
                  type="text"
                  id="friendName"
                  name="friendName"
                  value={formData.friendName}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="lastName"
                  className="block text-sm font-medium text-white"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div className="lg:flex lg:space-x-4">
              <div className="flex-1">
                <label
                  htmlFor="friendLocation"
                  className="block text-sm font-medium text-white"
                >
                  Friend's Location
                </label>
                <input
                  type="text"
                  id="friendLocation"
                  name="friendLocation"
                  value={formData.friendLocation}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              <div className="flex-1">
                <label
                  htmlFor="friendNumber"
                  className="block text-sm font-medium text-white"
                >
                  Friend's Number
                </label>
                <input
                  type="tel"
                  id="friendNumber"
                  name="friendNumber"
                  value={formData.friendNumber}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="friendEmail"
                className="block text-sm font-medium text-white"
              >
                Friend's Email
              </label>
              <input
                type="email"
                id="friendEmail"
                name="friendEmail"
                value={formData.friendEmail}
                onChange={handleChange}
                required
                className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <div>
              <label
                htmlFor="serviceTitle"
                className="block text-sm font-medium text-white"
              >
                Select Service Title
              </label>
              <select
                id="serviceTitle"
                name="serviceTitle"
                value={formData.serviceTitle}
                onChange={handleChange}
                required
                className="mt-1 block w-full p-2 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              >
                <option value="" disabled>
                  Select a service
                </option>
                {services.map((service, index) => (
                  <option key={index} value={service}>
                    {service.name}
                  </option>
                ))}
              </select>
            </div>

            <button
              type="submit"
              className="w-full bg-indigo-600 text-white p-2 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              Submit Booking
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Refer;
